/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IRequestContext } from '../interfaces';

export const GEOLOOKUP_CACHE_TYPE = 'GEOLOOKUP';
export interface IGeoLookupProvider {
    /**
     * Allows the geoLocation connector to do any startup related tasks
     * using the config provided by the partner.
     *
     * This method is only called once during server startup.
     * @param config The config provided by the partner in connector settings.
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    initialize(config: any): Promise<boolean>;

    /**
     * Geolocation lookup connector will get location information based on the ip address
     * @param ip The ip address
     */
    getGeoInformation(ip: string, requestContext: IRequestContext): Promise<IGeoLocation>;
}

export interface IGeoLocationConnector {
    name: string;
    provider: IGeoLookupProvider;
}

export interface IGeoLocation {
    country?: string;
    region?: string;
    city?: string;
    zipCode?: string;
    [otherProperty: string]: string | undefined;
}
